import { Badge } from '@/components/ui/badge'
import { AlertTriangle, Check, Clock, XCircle } from 'lucide-react'
import { FISCAL_STATUS_LABEL, type FiscalStatus } from '@/types/fiscal'

interface Props {
  operationalActive?: boolean
  fiscalStatus: FiscalStatus
  pendingSalesCount?: number
}

/**
 * Os dois status do item, lado a lado — a separação que sustenta o fluxo:
 * o item opera no Bewave (operacional) independente da homologação no Conta
 * Azul (fiscal). Um pendente não impede o outro.
 */
export default function FiscalStatusBadges({
  operationalActive = true,
  fiscalStatus,
  pendingSalesCount = 0,
}: Props) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <Badge variant="secondary" className="gap-1 text-xs">
        Operacional: {operationalActive ? 'Ativo' : 'Inativo'}
      </Badge>

      {fiscalStatus === 'homologated' && (
        <Badge variant="secondary" className="gap-1 text-xs text-emerald-700">
          <Check className="h-3 w-3" /> Fiscal:{' '}
          {FISCAL_STATUS_LABEL.homologated}
        </Badge>
      )}
      {fiscalStatus === 'pending' && (
        <Badge variant="outline" className="gap-1 text-xs text-amber-600">
          <Clock className="h-3 w-3" /> Fiscal: {FISCAL_STATUS_LABEL.pending}
        </Badge>
      )}
      {fiscalStatus === 'integration_error' && (
        <Badge variant="outline" className="gap-1 text-xs text-red-600">
          <XCircle className="h-3 w-3" /> Fiscal:{' '}
          {FISCAL_STATUS_LABEL.integration_error}
        </Badge>
      )}

      {pendingSalesCount > 0 && (
        <Badge
          variant="outline"
          className="gap-1 text-xs text-amber-700 border-amber-300"
        >
          <AlertTriangle className="h-3 w-3" />
          {pendingSalesCount}{' '}
          {pendingSalesCount === 1 ? 'venda aguardando' : 'vendas aguardando'}{' '}
          integração
        </Badge>
      )}
    </div>
  )
}
